import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Translator from '%app/js/common/services/translator';
import {
    COOKIE_SETTINGS_PORTAL_ID,
    COOKIE_SETTINGS_TRANSLATION_KEY,
} from '%paysera_service_agreement/js/CookiesUserAgreement/config/cookieSettingsPortal';

function resolveMountNode() {
    if (typeof document === 'undefined') {
        return null;
    }
    return document.getElementById(COOKIE_SETTINGS_PORTAL_ID);
}

function CookieSettingsPortalButton({ onClick }) {
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [mountNode, setMountNode] = useState(resolveMountNode);

    useEffect(() => {
        setMountNode(resolveMountNode());
    }, [location.pathname, isMobile]);

    if (!mountNode) {
        return null;
    }

    return ReactDOM.createPortal(
        <button
            type="button"
            onClick={onClick}
            data-testid="redesign-cookie-settings-button"
        >
            {Translator.trans(COOKIE_SETTINGS_TRANSLATION_KEY)}
        </button>,
        mountNode,
    );
}

CookieSettingsPortalButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default React.memo(CookieSettingsPortalButton);
